import { Router } from 'next/router';

export { default as Router, useRouter, withRouter } from 'next/router';
export { default } from 'next/router';

export type WebRouter = Router;
